// ##### 25-04-30 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';
import { useWindowWidthAndHeight } from '../../Helpers/WindowResizeHook';

// ##### Komarov 2025-07-14
const Cooperation = ({ pages, title, isWhiteLabelSet, companyCipher }) => {
  const cooperationRef = useRef();
  const cooperationItemsRef = useRef();
  // ##### 24-09-20 Komarov
  const [innerWidth] = useWindowWidthAndHeight();
  // ##### Komarov 2025-07-12
  useEffect(() => {
    cooperationItemsRef.current.style.left = `${cooperationRef.current.offsetLeft}px`;
  }, [innerWidth]);

  const removeCooperationItems = () => {
    const cooperationItemsclassList = cooperationItemsRef.current.classList;
    if (!cooperationItemsclassList.contains('DropDownMenuItemsHide')) {
      cooperationItemsclassList.add('DropDownMenuItemsHide');
    }
  };

  return (
    <OutsideClickHandler onOutsideClick={removeCooperationItems}>
      <a
        ref={cooperationRef}
        role="button"
        className="DropDownMenu"
        data-component="DropDownMenu"
        onClick={() =>
          cooperationItemsRef.current.classList.toggle('DropDownMenuItemsHide')
        }
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            cooperationItemsRef.current.classList.toggle(
              'DropDownMenuItemsHide'
            );
          }
        }}
      >
        {title}
      </a>
      <div
        className="DropDownMenuItemsHide"
        data-component="DropDownMenuItems"
        ref={cooperationItemsRef}
      >
        {pages.map(page => {
          return (
            // ##### 25-04-21 Komarov
            <LocalizationNavLink
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
              onClick={removeCooperationItems}
            >
              {/* ##### 25-03-26 Komarov */}
              {parse(page.title[0].text)}
            </LocalizationNavLink>
          );
        })}
      </div>
    </OutsideClickHandler>
  );
};

export default Cooperation;
